import { Chip } from '@mui/material';

type StatusVariant =
  | 'Active'
  | 'Inactive'
  | 'Open'
  | 'InProgress'
  | 'WaitingForCustomer'
  | 'WaitingForThirdParty'
  | 'Resolved'
  | 'Closed'
  | 'Reopened'
  | 'Critical'
  | 'Urgent'
  | 'High'
  | 'Normal'
  | 'Low'
  | 'Pending'
  | 'Completed'
  | 'NotStarted'
  | string;

const STATUS_MAP: Record<string, { bg: string; color: string; label?: string }> = {
  Active: { bg: 'rgba(16,185,129,0.15)', color: '#10B981' },
  Inactive: { bg: 'rgba(239,68,68,0.15)', color: '#EF4444' },
  Open: { bg: 'rgba(59,130,246,0.15)', color: '#3B82F6' },
  InProgress: { bg: 'rgba(249,115,22,0.15)', color: '#F97316' },
  WaitingForCustomer: { bg: 'rgba(234,179,8,0.15)', color: '#EAB308', label: 'Waiting Cust.' },
  WaitingForThirdParty: { bg: 'rgba(168,85,247,0.15)', color: '#A855F7', label: 'Waiting 3rd' },
  Resolved: { bg: 'rgba(16,185,129,0.15)', color: '#10B981' },
  Closed: { bg: 'rgba(100,116,139,0.15)', color: '#64748B' },
  Reopened: { bg: 'rgba(239,68,68,0.15)', color: '#EF4444' },
  Critical: { bg: 'rgba(127,29,29,0.4)', color: '#FCA5A5' },
  Urgent: { bg: 'rgba(239,68,68,0.15)', color: '#EF4444' },
  High: { bg: 'rgba(249,115,22,0.15)', color: '#F97316' },
  Normal: { bg: 'rgba(59,130,246,0.15)', color: '#3B82F6' },
  Low: { bg: 'rgba(100,116,139,0.15)', color: '#94A3B8' },
  Pending: { bg: 'rgba(249,115,22,0.15)', color: '#F97316' },
  Completed: { bg: 'rgba(16,185,129,0.15)', color: '#10B981' },
  NotStarted: { bg: 'rgba(100,116,139,0.15)', color: '#64748B', label: 'Not Started' },
};

interface StatusBadgeProps {
  status: StatusVariant;
  size?: 'small' | 'medium';
}

export function StatusBadge({ status, size = 'small' }: StatusBadgeProps) {
  const config = STATUS_MAP[status] ?? { bg: 'rgba(100,116,139,0.15)', color: '#94A3B8' };

  return (
    <Chip
      label={config.label ?? status}
      size={size}
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        fontWeight: 700,
        fontSize: '0.6875rem',
        height: 20,
        borderRadius: '4px',
        letterSpacing: '0.02em',
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
}
